<ng-container *ngIf="!isInExtraStep">
    <div class="frame-parent">
      <div class="title-wrapper">
        <div class="title">
          <div class="title1">{{ 'what-do-you-need' | translate }}</div>
        </div>
      </div>
    
    
      <div class="service-icon-circle-text-parent">
        <div *ngFor="let item of result">
          <div class="service-icon-circle-text" id="serviceIconCircleText" (click)="onServiceSelected(item)">
            <div
            class="services-iconsservice-icon"
            >
            <img class="services-icons4" alt="" [src]="item.icon" />
            </div>
            <div class="transfer">{{ item.title | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
    
    <router-outlet></router-outlet>
